/**
 * Maximum number of photos/documents allowed per section.
 * To change a limit, update the value for the relevant section ID here.
 * Sections not listed fall back to DEFAULT_PHOTO_LIMIT.
 */
export const PHOTO_LIMITS: Record<string, number> = {
  'form-recognizer':    2,
  'valuation-report':   5,
  'basic-information':  5,
  'standard-equipment': 5,
  'additional-options': 5,
  'body-information':   5,
  'vehicle-condition':  5,
}

export const DEFAULT_PHOTO_LIMIT = 5

export function getPhotoLimit(sectionId: string): number {
  return PHOTO_LIMITS[sectionId] ?? DEFAULT_PHOTO_LIMIT
}
